import React from 'react';
import { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';

export const IconRight = ({ classProps }: PropsWithClassProps) => {
  return (
    <svg
      className={twMerge('h-4 w-4', classProps?.root)}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 10.9999L9 6.99988L5 2.99988" stroke="currentColor" />
    </svg>
  );
};
